import Component from "@lib/Component.js";
import Slider from "../helpers/slider";

export default class MayInterest extends Component {
  onEnter() {
    super.onEnter();

    if (this.refs.items && this.refs.items.length > 0) {
      this.slider = new Slider({
        items: this.refs.items,
        prevButton: this.refs["prev-button"],
        nextButton: this.refs["next-button"],
        itemsPerPage: () => {
          if (window.innerWidth >= 1200) return 3;
          if (window.innerWidth >= 768) return 2;
          return 1;
        }
      });
    }
  }

  onLeaveCompleted() {
    super.onLeaveCompleted();
    if (this.slider) this.slider.destroy();
  }
}



// WEBPACK FOOTER //
// ./scripts/components/MayInterest.js